<template>
	<!-- goPage('news',13) -->
	<div class="min-h main-in">
		<div class="f-row-start-l wrap">
			<div class="w-50 overf-h pl-1 mt-1">
				<el-carousel indicator-position="none" :autoplay="true" height="420px" ref="img" v-if="provinceDynamicList.length > 0">
					<el-carousel-item v-for="(item, aind) in provinceDynamicList" :key="aind" v-if="item.img">
						<div class="pinter" @click="$util.goPage('newDetail', 8, item.id)"><img :src="$imgUrl + item.img" class="w-100" /></div>
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="w-50">
				<div class="box">
					<div class="btn pinter" @click="$util.goPage('news', 8)">省级团委动态</div>
					<div class="cont">
						<div v-for="(item, i) in provinceDynamicList" :key="i" :title="item.title" class="pinter">
							<div class="overf-elli item act-h" :title="item.title" @click="$util.goPage('newDetail', 8, item.id)">
								<div class="triangle"></div>
								{{ item.title ? item.title : '' }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="f-row-b align-start pl-1 pr-1 mt12 wrap">
			<div class="w-50">
				<div class="tabs">
					<div class="bb-1 f-row-b ">
						<span class="bbact">市州县团委动态</span>
						<div class="font-2 pinter color-red" @click="$util.goPage('news', 9)">更多&gt;</div>
					</div>
					<div class="tabs-cont">
						<div v-for="(item, i) in cityDynamicList" :key="i" :title="item.title">
							<div class="item pinter f-row-b" @click="$util.goPage('newDetail', 9, item.id)">
								<div class="overf-elli act-h w-90" :title="item.title">
									<div class="triangle"></div>
									{{ item.title ? item.title : '' }}
								</div>
								<!-- <div class="color-gray time act-h mt-1">{{ item.subtitle ? item.subtitle : '' }}</div> -->
								<div class="color-gray time act-h mt-1">{{ item.createTime | timeFilter }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="w-50 right">
				<div class="tabs">
					<div class="bb-1 f-row-b ">
						<span class="bbact">少先队动态</span>
						<div class="font-2 pinter color-red" @click="$util.goPage('news', 102)">更多&gt;</div>
					</div>
					<div class="tabs-cont">
						<div v-for="(item, i) in teamBuildingDynamicList" :key="i" :title="item.title">
							<div class="item pinter f-row-b" @click="$util.goPage('newDetail', 102, item.id)">
								<div class="overf-elli act-h w-90" :title="item.title">
									<div class="triangle"></div>
									{{ item.title ? item.title : '' }}
								</div>
								<div class="color-gray time act-h mt-1">{{ item.createTime | timeFilter }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="w-50">
				<div class="tabs">
					<div class="bb-1 f-row-b ">
						<span class="bbact">企业团委动态</span>
						<div class="font-2 pinter color-red" @click="$util.goPage('news', 101)">更多&gt;</div>
					</div>
					<div class="tabs-cont">
						<div v-for="(item, i) in companyDynamicList" :key="i" :title="item.title">
							<div class="item pinter f-row-b" @click="$util.goPage('newDetail', 101, item.id)">
								<div class="overf-elli act-h w-90" :title="item.title">
									<div class="triangle"></div>
									{{ item.title ? item.title : '' }}
								</div>
								<div class="color-gray time act-h mt-1">{{ item.createTime | timeFilter }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="w-50 right">
				<div class="tabs">
					<div class="bb-1 f-row-b ">
						<span class="bbact">高校团委动态</span>
						<div class="font-2 pinter color-red" @click="$util.goPage('news', 31)">更多&gt;</div>
					</div>
					<div class="tabs-cont">
						<div v-for="(item, i) in schoolDynamicList" :key="i" :title="item.title">
							<div class="item pinter f-row-b" @click="$util.goPage('newDetail', 31, item.id)">
								<div class="overf-elli act-h w-90" :title="item.title">
									<div class="triangle"></div>
									{{ item.title ? item.title : '' }}
								</div>
								<div class="color-gray time act-h mt-1">{{ item.createTime | timeFilter }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="w-50 right">
                <div class="tabs">
                    <div class="tabs-header flex bb-1 f-row-b">
                        <span  class="bbact">基层组织工作动态</span>
                        <div class="font-2 pinter color-red" @click="$util.goPage('news',26)">更多&gt;</div>
                    </div>
                    <div class="tabs-cont">
                        <div v-for="(item, i) in basicLevelInfo" :key="i" :title="item.title" >
                            <div class="item act-h pinter" @click="$util.goPage('newDetail',26,item.id)">
                                <img :src='item.img?$imgUrl+item.img.split(",")[0]:$defult' class="w-100 pb-1" v-if='i==0'/>
                                <div class="overf-elli" :title="item.title">
                                    <div class="triangle"></div>{{item.title?item.title:''}}
                                </div>
                                <div class="color-gray time mt-1">{{item.createTime|timeFilter}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
		</div>
	</div>
</template>

<script>
import { queryWorkNewsData } from '@/axios/api';
export default {
	filters: {
		timeFilter(val) {
			var time = '';
			if (!val) {
				return time;
			}

			if (val) {
				var dataArr = val.split(' ')[0].split('-');
				time = dataArr[1] + '-' + dataArr[2];
			}
			return time;
		}
	},
	data() {
		return {
			lunbo: [
				{
					createBy: 'admin',
					createTime: '2021-06-16',
					id: '1405043379053670401',
					isFlag: '0',
					slideshowImg: 'temp/门户002_1626255638969.png',
					slideshowLink: 'baidu.com',
					slideshowName: '庆祝中国共产党成立100周年',
					slideshowSort: '3',
					updateBy: 'admin',
					updateTime: '2021-07-19'
				}
			],
			// mediaFocus: [], //媒体聚焦
			provinceDynamicList: [], //省
			cityDynamicList: [], //市
			countyDynamicList: [], //县
			schoolDynamicList: [], // 高校
			companyDynamicList: [], // 企业
			teamBuildingDynamicList: [], // 少工委
			// provincialInfo: [], //团省委工作动态
			// basicLevelInfo: [], //基层组织工作动态
			list: [
				{
					imgs: require('../../assets/img/photo1.png'),
					title: '我省举行深化税收征管改革的实施方案有关情况新闻发布会',
					subtitle: '我省举行深化税收征管改革的实施方案有关情况新闻发布会',
					createTime: '2021-10-22'
				},
				{ title: '我省举行深化税收征管改革的实施方案有关情况新闻发布会', createTime: '2021-10-22' },
				{ title: '我省举行深化税收征管改革的实施方案有关情况新闻发布会', createTime: '2021-10-22' }
			]
		};
	},

	created() {
		// this.init();
		this.queryWorkNewsData();
	},

	methods: {
		queryWorkNewsData() {
			queryWorkNewsData().then(res => {
				console.log('res:', res);

				this.provinceDynamicList = res.result.provinceDynamicList;
				//省
				this.cityDynamicList = res.result.cityDynamicList;

				//市县
				this.countyDynamicList = res.result.countyDynamicList;

				//高校
				this.schoolDynamicList = res.result.schoolDynamicList;
				//企业
				this.companyDynamicList = res.result.companyDynamicList;
				//少工委
				this.teamBuildingDynamicList = res.result.teamBuildingDynamicList;
			});
		},
		init() {
			// this.getMediaFocus();
			// this.getProvincialInfo();
			// this.getBasicLevelInfo();
		},
		getMediaFocus() {
			//媒体聚焦
			var param = {
				pageNo: 1, //分页
				pageSize: 6,
				msgType: 15
			};
			this.$get('/web/information/list', param).then(res => {
				this.mediaFocus = res.result.records;
			});
		},
		getProvincialInfo() {
			//团省委工作动态
			var param = {
				pageNo: 1,
				pageSize: 6,
				msgType: 23
			};
			this.$get('/web/information/list', param).then(res => {
				this.provincialInfo = res.result.records;
			});
		},
		getBasicLevelInfo() {
			//基层组织工作动态
			var param = {
				pageNo: 1,
				pageSize: 6,
				msgType: 21
			};
			this.$get('/web/information/list', param).then(res => {
				this.basicLevelInfo = res.result.records;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.box {
	box-sizing: border-box;
	padding-left: 10px;
	.cont {
		margin-top: 10px;
		padding-left: 30px;
		margin-right: 20px;
	}
	.btn {
		margin: auto;
		margin-top: 10px;
		max-width: 544px;
		height: 44px;
		line-height: 44px;
		background: #ba0711;
		border-radius: 5px;
		text-align: center;
		color: #ffffff;
	}
}

.right {
	padding-left: 40px;
}
.item {
	border-bottom: 1px dashed #e0e0e0;
	padding: 15px 0px;
	font-size: 16px;
	.time {
		font-size: 14px;
		width: 40px;
	}
}
</style>
